import React from 'react'
import styled from 'styled-components'
import {browserHistory} from 'react-router'
import ItemImageList from '../../../finwhale/common/item/image-list'
import getImgUrl from '../../../getImgUrl'
import { cloneDeep } from 'lodash';

const Container = styled.div`
  display: flex;
  font-size: 15px;
  padding: 10px;
  padding-left: 0;
`

const Param = ({name, value, marginLeft, highlighted}) => (
  <div style={{minHeight: 25, marginLeft, alignItems: 'flex-start', display: 'flex', marginTop: 10}}>
    <div style={{display: 'inline-block', width: 165, fontWeight: 800, verticalAlign: 'top'}}>{name}</div>
    <div
      style={{
        verticalAlign: 'top',
        display: 'inline-block',
        whiteSpace: 'normal',
        flex: 1,
      }}
    >
      {value}
    </div>
  </div>
)

const A = styled.a`
  display: block;
  font-weight: initial;
  font-size: 1.8em;
  text-decoration: none;
  margin-bottom: 20px;
  font-weight: 800;
  ${props => props.isLink && 'color: #0054ff; cursor: pointer; &:hover { color: red; }'}
`

const AutoPartCard = ({href, title, code, data, width, length, execution, weight, agregat, img, children, schemaList, imageList}) => {
  const array = toArray(cloneDeep(data)).sort(obj => Object.values(obj)[0] === code ? -1 : 0);
  const columns = split(array, getColumnsLength(array));

  // console.log({data});

  return (
    <Container>
      <ItemImageList
        style={{
          width: 400,
        }}
        list={
          (imageList || schemaList)
            ?
            [
              ...(imageList || []).map(e => e ? getImgUrl(`/media/static/product_photos/${e}`) : null),
              ...(schemaList || []).map(e => e ? getImgUrl(`/media/static/schema/${e}`) : null),
            ]
            : [img]
        }
      />
      <div style={{paddingLeft: 25, flexGrow: 0, flexShrink: 1, marginLeft: 'auto', width: '70%'}}>
        <A
          isLink={href}
          onClick={() => {
            if (href) {
              browserHistory.push(href)
            }
          }}
        >
          {title}
        </A>
        <div style={{display: 'flex', flexDirection: 'wrap', flexWrap: 'noWrap'}}>
          {
            columns.map((column, i) => {
              return (
                <div
                  style={{
                    ...(i > 0 && {marginLeft: 100}),
                  }}
                >
                  {
                    column.map(e => <Param name={Object.keys(e)[0]} value={e[Object.keys(e)[0]]}/>)
                  }
                </div>
              )
            })
          }
        </div>
        {children}
      </div>
    </Container>
  )
}

function getColumnsLength(array) {
  return 2
}

function toArray(d) {
  let result = [];
  (function recur(data) {
    return data && Object.keys(data).map(param => {
      if (typeof data[param] === 'object') {
        return recur(data[param])
      }
      result.push({[param]: data[param]})
    })
  })(d)
  return result
}

function split(array, count) {
  let result = []
  let i = 0
  let begin = 0
  let chunkSize = Math.floor(array.length / count) + 1
  for (; i < array.length % count; ++i) {
    result.push(array.slice(begin, begin + chunkSize))
    begin += chunkSize
  }
  chunkSize = Math.floor(array.length / count)
  for (; i < count; ++i) {
    result.push(array.slice(begin, begin + chunkSize))
    begin += chunkSize
  }
  return result
}

export default AutoPartCard



// WEBPACK FOOTER //
// ./src/finwhale/common/auto-part-card/Desktop.js